import {
    announceAssignmentResourceStatus,
    replaceAssignmentResourceList
} from './assignment_resource_list';

document.addEventListener('turbolinks:load', function () {
    const assignment_library_content = document.getElementById("assignment_resource");

    if (assignment_library_content == null) {
        return
    }

    window.assignment_resource_content_search_initializer = (premade = true) => {
        window.filterData = {
            format: 'json',
            premade: premade,
            topics: [],
            combos: [],
            types: [],
            search_word: "",
            courses: []
        }

        let debounceTimer = null;
        let isComposing = false;
        let filterRequest = null;
        let filterRequestGeneration = 0;

        const $reset_button = $("#assignment_resource_search_reset");
        const $input = $('#assignments-resources-live-search');

        const filterResources = () => {
            const filterPath = '/assignment_resources';
            const requestGeneration = ++filterRequestGeneration;
            filterRequest?.abort();
            document.getElementById('assignment-resource-list-region')?.setAttribute('aria-busy', 'true');
            filterRequest = $.ajax({
                type: "GET",
                url: filterPath,
                data: filterData,
                dataType: 'json',
                success: function(response) {
                    if (requestGeneration !== filterRequestGeneration) return;

                    replaceAssignmentResourceList(response.assignment_resources_html, {
                        totalCount: response.total_count
                    });
                    searching_hide_show_html(response)
                    open_folders(filtering());
                },
                error: function(_xhr, status) {
                    if (status === 'abort' || requestGeneration !== filterRequestGeneration) return;

                    document.getElementById('assignment-resource-list-region')?.setAttribute('aria-busy', 'false');
                    announceAssignmentResourceStatus('Assignments could not be updated. Please try again.');
                },
                complete: function() {
                    if (requestGeneration === filterRequestGeneration) filterRequest = null;
                }
            });
        }
        window.refreshAssignmentResourceList = filterResources;

        const searching_hide_show_html = (response) => {
            const $topic_dropdown = $("#topic_dropdown")
            const $subtopic_dropdown = $("#subtopic_dropdown")
            const $course_dropdown = $("#course_dropdown")
            const $collections_dropdown = $("#collections_dropdown")
            const $reset_button = $("#assignment_resource_search_reset");
            const hasSearch = filterData.search_word.length > 0;
            const html = response?.tabs_html;

            if (hasSearch) {
                reset_filter("search")
                $topic_dropdown.hide()
                $subtopic_dropdown.hide()
                $course_dropdown.hide()
                $collections_dropdown.hide()
                $reset_button.removeClass("d-none")
                if (typeof html === "string") {
                    document.getElementById("assignment_resource_bar_context").innerHTML = html;
                }
                count_search_results(response?.total_count)
            } else {
                $topic_dropdown.show()
                $subtopic_dropdown.show()
                $course_dropdown.show()
                $collections_dropdown.show()
                $reset_button.addClass("d-none")

                if (typeof html === "string") {
                    document.getElementById("assignment_resource_bar_context").innerHTML = html;
                }
            }

            window.assignmentResourceNotifications?.renderTabCount();
        }

        const selectedIds = (selectedFilterQuery) => {
            return selectedFilterQuery
                .toArray()
                .map(option => $(option).data('id'))
        }

        const intersectingCombos = (selectedTopicsQuery, selectedSubtopicsQuery) => {
            const selectedTopicCombos = [].concat.apply([], selectedTopicsQuery
                .toArray()
                .map(option => $(option).data('combos')))

            const selectedSubtopicCombos = [].concat.apply([], selectedSubtopicsQuery
                .toArray()
                .map(option => $(option).data('combos')))

            return selectedTopicCombos.filter(combo => selectedSubtopicCombos.includes(combo))
        }

        $input.off('.arSearch')

        $input.on('keydown.arSearch', (e) => {
            if (e.which === 13) {
                e.preventDefault();
            }
        });

        $input.on('compositionstart.arSearch', () => {
            isComposing = true;
        });

        $input.on('compositionend.arSearch', (e) => {
            isComposing = false;
        });

        $input.on('keyup.arSearch', (e) => {
            if (e.which === 13 || isComposing) return;
            scheduleSearch(e.target.value);
            if (e.target.value.length === 0) searching_hide_show_html(null, false)
        });

        function scheduleSearch(rawValue) {
            const value = (rawValue || '');

            clearTimeout(debounceTimer);

            const shouldSearch = value.length >= 2 || value.length === 0;
            if (!shouldSearch) return;

            debounceTimer = setTimeout(() => {
                filterData.search_word = value;
                filterResources();
            }, 500);
        }

        $reset_button.on("click.arSearch", function(e) {
            const $input = $('#assignments-resources-live-search');
            $input.val("")
            filterData.search_word = ""
            filterResources();
        })

        $('.ia-header-filter-checkbox').change(function (e) {
            const $header = $(this);
            const headerId = $header.data('id');
            const checked = $header.prop('checked');
            const $topics = $(`.filter-checkbox[data-header="${headerId}"]`);
            const $toChange = checked ? $topics.not(':checked') : $topics.filter(':checked');

            $toChange.prop('checked', checked);
            handleFilterOptionSelected('topic');
        })

        $("#reset_filter_button").on("click", function(e) {
            reset_filter()
        })

        $('.filter-checkbox').change(function (e) {
            const $checkbox = $(this);
            handleFilterOptionSelected($checkbox.data('type'));

            const headerType = $checkbox.data('header');
            if (headerType == null) return; // no associated header, done

            const $group = $(`.filter-checkbox[data-header="${headerType}"]`);
            const allChecked = $group.length > 0 && $group.filter(':checked').length === $group.length;
            const $header = $(`#filter-option-checkbox-header-${headerType}`);
            $header.prop('checked', allChecked);
        })

        const handleFilterOptionSelected = (type) => {
            const selectedTopicsQuery = $('#topic_options :checked').not('.ia-header-filter-checkbox')
            const selectedSubtopicsQuery = $('#subtopic_options :checked')
            const selectedActivityTypes = $('#activity_type_options :checked')
            const selectedCourses = $('#course_options :checked')

            switch (type) {
                case "topic":
                    const selected_topics = selectedTopicsQuery.toArray().map(option => $(option).data('id'))
                    const subtopicDropdown = $('#subtopic_dropdown')
                    const subtopicSummary = $('#subtopic_summary')
                    const subtopicOptions = $('#subtopic_options')
                    const topic_count_html = $("#filter_label_topic")

                    if (selected_topics.length <= 0) {
                        subtopicSummary.addClass("disabled")
                        subtopicDropdown.removeAttr('open');
                        selectedSubtopicsQuery.each(function () {
                            $(this).prop("checked", false).trigger("change")
                        })
                        topic_count_html.html(0)
                        topic_count_html.addClass("d-none")
                    } else {
                        subtopicDropdown.attr('open', true);
                        subtopicSummary.removeClass("disabled")
                        topic_count_html.html(selected_topics.length)
                        topic_count_html.removeClass("d-none")

                        const selectedCombos = [].concat.apply([], selectedTopicsQuery
                            .toArray()
                            .map(option => $(option).data('combos')))

                        subtopicOptions.children().each(function () {
                            const subtopic = $(this)
                            const subtopicCheckbox = subtopic.find('input')
                            const shouldEnable = subtopicCheckbox.data('combos')
                                .some(combo => selectedCombos.indexOf(combo) >= 0)
                            if (shouldEnable) {
                                subtopic.show()
                            } else {
                                // subtopicCheckbox.prop("checked", false).trigger("change")
                                subtopic.hide()
                            }
                        })

                        // Set the array of selected topics as the topic filter data.
                        // filterData.topics = selected_topics
                    }
                    break;

                // We selected a subtopic.
                case "subtopic":
                    const selected_subtopics = selectedSubtopicsQuery.toArray().map(option => $(option).data('id'))
                    const subtopic_count_html = $("#filter_label_subtopic")
                    if (selected_subtopics.length <= 0) {
                        subtopic_count_html.html(0)
                        subtopic_count_html.addClass("d-none")
                    } else {
                        subtopic_count_html.html(selected_subtopics.length)
                        subtopic_count_html.removeClass("d-none")
                    }
                    break;

                // We selected a type.
                case "type":
                    const selected_types = selectedActivityTypes.toArray().map(option => $(option).data('id'))
                    filterData.types = selected_types
                    const types_count_html = $("#filter_label_activity_types")
                    if (selected_types.length <= 0) {
                        types_count_html.html(0)
                        types_count_html.addClass("d-none")
                    } else {
                        types_count_html.html(selected_types.length)
                        types_count_html.removeClass("d-none")
                    }
                    break;

                case "course":
                    const selected_courses = selectedCourses.toArray().map(option => $(option).data('id'))
                    filterData.courses = selected_courses
                    let selected_courses_count_html;

                    if (premade === true) {
                        selected_courses_count_html = $("#filter_label_courses")
                    } else {
                        selected_courses_count_html = $("#filter_label_my_courses")
                    }

                    if (selected_courses.length <= 0) {
                        selected_courses_count_html.html(0)
                        selected_courses_count_html.addClass("d-none")
                    } else {
                        selected_courses_count_html.html(selected_courses.length)
                        selected_courses_count_html.removeClass("d-none")
                    }
                    break;
            }

            // Final check for all selected topics.
            filterData.topics = selectedIds(selectedTopicsQuery)

            // Final check for all selected subtopics.
            filterData.combos = intersectingCombos(selectedTopicsQuery, selectedSubtopicsQuery)

            update_total_count()
            filterResources()
        }

        const reset_filter = (type = null) => {
            const isSearchReset = (type === "search");
            const subtopicSummary = $('#subtopic_summary')
            const subtopicDropdown = $('#subtopic_dropdown')
            let count_icons

            filterData.topics = []
            filterData.combos = []
            filterData.courses = []

            if (isSearchReset) {
                $(".filter-checkbox")
                    .not("#activity_type_options .filter-checkbox")
                    .prop("checked", false);

                count_icons = $(".assignment_resource__filter-section__title__label__icon").not("#filter_label_activity_types")
            } else {
                filterData.types = [];
                $(".filter-checkbox").prop("checked", false);
                count_icons = $(".assignment_resource__filter-section__title__label__icon")
            }

            $(".ia-header-filter-checkbox").prop("checked", false);
            subtopicSummary.addClass("disabled")
            subtopicDropdown.removeAttr('open');
            update_total_count()
            count_icons.addClass("d-none")
            count_icons.html(0)

            if (!isSearchReset) {
                filterResources()
            }
        }

        const update_total_count = () => {
            const total_count =
                filterData.topics.length +
                filterData.combos.length +
                filterData.types.length +
                filterData.courses.length;

            const $wrap = $("#total_count_wrapper");

            if (total_count <= 0) {
                $("#assignment_resource_bar_actions").show()
                $wrap.removeClass('show')
            } else {
                $("#assignment_resource_bar_actions").hide()
                $wrap.addClass('show');
                $("#total_count").text(total_count);
            }
        };
    }

    window.count_search_results = (totalCount = null) => {
        const count_element = $("#assignment_resource_results_count")
        if (count_element) {
            const newCount = totalCount == null ? document.querySelectorAll(
                "li.assignment_resource__main_panel__form__resources__card .assignment_resource__main_panel__form__resources__card__primary-information"
            ).length : totalCount;
            count_element.text(newCount);
        }
    }

    const open_folders = (should_default_open) => {
        if (should_default_open) {
            $('.collapse').collapse('show')
        }
    }

    const filtering = () => {
        const total_count =
            filterData.topics.length +
            filterData.combos.length +
            filterData.types.length +
            filterData.courses.length +
            filterData.search_word.length

        return total_count > 0
    }

    const is_vb = $("#is_vb").val()
    assignment_resource_content_search_initializer(is_vb)
});
